import { CallIcon, EmailIcon, Stepper, UserScanIcon } from "@cpj-ai/panel-npm-package";
import { useCallback, useMemo, useState } from "react";
import VerificationLayout from "../VerificationMethodLayout";
import EnterOrgEmailAndPhoneStep from "./EnterOrgEmailAndPhoneStep";
import EnterOtpCodeStep from "./EnterOtpCodeStep";
import ResultStep from "./ResultStep";

export interface VerificationState {
  email: string;
  phone: string;
}

const PhoneVerification = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [reviewingStep, setReviewingStep] = useState<number | null>(null);
  const [verificationData, setVerificationData] = useState<VerificationState>({
    email: "",
    phone: "",
  });

  const steps = useMemo(() => {
    return [
      {
        label: "Enter Details",
        icon: <EmailIcon stroke="#fff" className="w-6 h-6" viewBox="0 0 20 20" />,
      },
      {
        label: "Verify Number",
        icon: <UserScanIcon stroke="#fff" className="w-6 h-6" />,
      },
      {
        label: "Confirmation",
        icon: <CallIcon stroke="#fff" className="w-6 h-6" />,
      },
    ];
  }, []);

  const handleNextStep = useCallback(
    (data?: VerificationState) => {
      if (data) {
        setVerificationData(data);
      }
      if (reviewingStep !== null) {
        setReviewingStep(null);
      } else {
        setActiveStep((prev) => Math.min(prev + 1, steps.length + 1));
      }
    },
    [reviewingStep, steps.length],
  );

  const onReviewStep = useCallback((stepNumber: number | null) => {
    setReviewingStep(stepNumber);
  }, []);

  const _renderStep = useCallback(() => {
    const stepToShow = reviewingStep ?? activeStep;

    switch (stepToShow) {
      case 1:
        return <EnterOrgEmailAndPhoneStep handleNextStep={handleNextStep} initialData={verificationData} />;
      case 2:
        return <EnterOtpCodeStep handleNextStep={handleNextStep} phoneNumber={verificationData.phone} />;
      case 3:
        return <ResultStep verificationData={verificationData} />;
      default:
        return null;
    }
  }, [activeStep, handleNextStep, reviewingStep, verificationData]);

  return (
    <VerificationLayout verifyType="Phone Verification">
      <div className="md:w-7/12 block mx-auto">
        <Stepper
          classNames={{ base: "md:w-10/12 mt-4 md:mt-3 mb-1 !p-0 md:!p-4" }}
          steps={steps}
          activeStep={activeStep}
          reviewingStep={reviewingStep}
          onReviewStep={onReviewStep}
        />
        {_renderStep()}
      </div>
    </VerificationLayout>
  );
};

export default PhoneVerification;
